import { render, staticRenderFns } from "./BuyWork.vue?vue&type=template&id=1488b60d&scoped=true&"
import script from "./BuyWork.vue?vue&type=script&lang=js&"
export * from "./BuyWork.vue?vue&type=script&lang=js&"
import style0 from "./BuyWork.vue?vue&type=style&index=0&id=1488b60d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1488b60d",
  null
  
)

export default component.exports